module.exports = __webpack_public_path__ + "static/terra-mattress-firmness-7e8f5f1d2d42ecfdf25f995500108c8e.mp4";